import slick from 'slick-carousel';
import './navigation';
import './skip-link-focus-fix';

document.addEventListener( "DOMContentLoaded", () => {

	const headerHeight = $( '#masthead' ).outerHeight();
	const urlHash = location.hash;
	if ( urlHash ) {
		$( 'body,html' ).stop().scrollTop( 0 );
		setTimeout( () => {
			const target = $( urlHash );
			const position = target.offset().top - headerHeight - 16;
			$( 'body,html' ).stop().scrollTop( position );
		}, 100 );
	}
	$( 'a[href^="#"]' ).on( "click", ( e ) => {
		e.preventDefault();
		const href = $( e.currentTarget ).attr( "href" );
		const target = $( href );
		const position = target.offset().top - headerHeight - 16;
		$( 'body,html' ).stop().animate( { scrollTop: position }, 500 );
	} );

	initGallerySlider();
} );


function initGallerySlider() {
	const gallerySlider = document.querySelectorAll( '.ah-use-gallery-slider .wp-block-gallery,.ah-use-gallery-slider .blocks-gallery-grid' );
	if ( ! gallerySlider ) {
		return;
	}

	gallerySlider.forEach( ( element ) => {
		const config = {
			autoplay: false,
			speed: 500,
			fade: true,
			dots: true,
		};
		$( element ).slick( config );
	} );
}
